
<div class="home">
  <div class="home-container">

  <!-- Left Side: Welcome Text -->
  <div class="welcome-section">
    <h1 class="welcome-title">
      Welcome, {{ profile?.displayName }}!
    </h1>

    <p class="welcome-subtitle">
      Use the navigation above to explore your available features.
    </p>
  </div>

  <!-- Right Side: 4 Cards -->
  <div class="cards-grid">

    <div class="info-card">
      <h3>Commission Fact 1</h3>
      <p>Placeholder text for commission insight.</p>
    </div>

    <div class="info-card">
      <h3>Commission Fact 2</h3>
      <p>Placeholder text for commission insight.</p>
    </div>

    <div class="info-card">
      <h3>Commission Fact 3</h3>
      <p>Placeholder text for commission insight.</p>
    </div>

    <div class="info-card">
      <h3>Commission Fact 4</h3>
      <p>Placeholder text for commission insight.</p>
    </div>

  </div>

</div>
</div>


